import boardsGroups from './boards_groups';
import groups from './groups';

const boardsgroupsModule = {
  modules: {
    boardsGroups,
    groups,
  },
};

export default boardsgroupsModule;
